/* About page hero: YouTube player with sound-first autoplay and an expand-to-popup player. */
(function () {
  var API_SRC = 'https://www.youtube.com/iframe_api';
  var PLAYING = 1;

  function whenApiReady(cb) {
    if (window.YT && window.YT.loaded) {
      cb();
      return;
    }
    var prev = window.onYouTubeIframeAPIReady;
    window.onYouTubeIframeAPIReady = function () {
      if (typeof prev === 'function') prev();
      cb();
    };
    if (!document.querySelector('script[src="' + API_SRC + '"]')) {
      var tag = document.createElement('script');
      tag.src = API_SRC;
      tag.async = true;
      document.head.appendChild(tag);
    }
  }

  function playerVars(extra) {
    var vars = { playsinline: 1, rel: 0, modestbranding: 1, origin: window.location.origin };
    for (var key in extra) vars[key] = extra[key];
    return vars;
  }

  function setTitle(player, title) {
    try {
      if (title) player.getIframe().setAttribute('title', title);
    } catch (e) {}
  }

  function init(root) {
    var box = root.querySelector('[data-c-yt-id]');
    if (!box || box.hasAttribute('data-c-yt-ready')) return;
    box.setAttribute('data-c-yt-ready', '');

    var videoId = box.getAttribute('data-c-yt-id');
    var title = box.getAttribute('data-c-yt-title');
    var slot = box.querySelector('[data-c-yt-inline]');
    var soundBtn = box.querySelector('[data-c-yt-sound]');
    var expandBtn = root.querySelector('[data-c-yt-expand]');
    var modal = root.querySelector('[data-c-yt-modal]');
    var modalSlot = root.querySelector('[data-c-yt-modal-slot]');
    var closeBtn = root.querySelector('[data-c-yt-close]');
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var inline = null;
    var popup = null;

    function syncSoundButton() {
      if (!inline || !soundBtn) return;
      try {
        soundBtn.hidden = !inline.isMuted();
      } catch (e) {}
    }

    whenApiReady(function () {
      inline = new window.YT.Player(slot, {
        videoId: videoId,
        playerVars: playerVars({ autoplay: 0, controls: 1 }),
        events: {
          onReady: function () {
            setTitle(inline, title);
            if (reduceMotion) return;
            // Try with sound first. Browsers block that without a prior click,
            // so fall back to muted autoplay and offer a sound button.
            inline.unMute();
            inline.playVideo();
            setTimeout(function () {
              if (inline.getPlayerState() !== PLAYING) {
                inline.mute();
                inline.playVideo();
              }
              syncSoundButton();
            }, 1500);
          },
          onStateChange: syncSoundButton
        }
      });
    });

    if (soundBtn) {
      soundBtn.addEventListener('click', function () {
        if (!inline) return;
        inline.unMute();
        inline.setVolume(100);
        inline.playVideo();
        soundBtn.hidden = true;
      });
    }

    if (!expandBtn || !modal || typeof modal.showModal !== 'function') {
      if (expandBtn) expandBtn.hidden = true;
      return;
    }

    expandBtn.addEventListener('click', function () {
      var start = 0;
      if (inline && inline.getCurrentTime) {
        start = Math.floor(inline.getCurrentTime() || 0);
        inline.pauseVideo();
      }

      modalSlot.innerHTML = '<div></div>';
      document.documentElement.style.overflow = 'hidden';
      modal.showModal();

      whenApiReady(function () {
        popup = new window.YT.Player(modalSlot.firstChild, {
          videoId: videoId,
          playerVars: playerVars({ autoplay: 1, start: start, controls: 1 }),
          events: {
            onReady: function () {
              setTitle(popup, title);
              popup.unMute();
              popup.playVideo();
            }
          }
        });
      });
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        modal.close();
      });
    }

    modal.addEventListener('click', function (event) {
      if (event.target === modal) modal.close();
    });

    modal.addEventListener('close', function () {
      var resumeAt = null;
      if (popup) {
        try {
          resumeAt = popup.getCurrentTime();
          popup.destroy();
        } catch (e) {}
        popup = null;
      }
      modalSlot.innerHTML = '';
      document.documentElement.style.overflow = '';

      if (inline && inline.seekTo) {
        if (resumeAt != null) inline.seekTo(resumeAt, true);
        inline.playVideo();
      }
      expandBtn.focus();
    });
  }

  function initAll() {
    document.querySelectorAll('[data-c-about-hero]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
